import { styled } from '@linaria/react';
export const OfferLinkWrapper = /*#__PURE__*/styled('a')({
  name: "OfferLinkWrapper",
  class: "o1u6dz7h",
  propsAsIs: false
});
export const LockedDealWrapper = /*#__PURE__*/styled('span')({
  name: "LockedDealWrapper",
  class: "luho2xk",
  propsAsIs: false
});

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");